import { NgClass, NgComponentOutlet, NgTemplateOutlet } from '@angular/common';
import { Component, input, Type, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { FormAutocompleteFieldComponent } from '../fields/form-autocomplete-field/form-autocomplete-field.component';
import { FormCheckboxFieldComponent } from '../fields/form-checkbox-field/form-checkbox-field.component';
import { FormCheckboxGroupFieldComponent } from '../fields/form-checkbox-group-field/form-checkbox-group-field.component';
import { FormDatePickerFieldComponent } from '../fields/form-date-picker-field/form-date-picker-field.component';
import { FormDateTimePickerFieldComponent } from '../fields/form-date-time-picker-field/form-date-time-picker-field.component';
import { FormDropdownFieldComponent } from '../fields/form-dropdown-field/form-dropdown-field.component';
import { FormNumberFieldComponent } from '../fields/form-number-field/form-number-field.component';
import { FormPasswordFieldComponent } from '../fields/form-password-field/form-password-field.component';
import { FormTextAreaFieldComponent } from '../fields/form-text-area-field/form-text-area-field.component';
import { FormTextFieldComponent } from '../fields/form-text-field/form-text-field.component';
import { FormToggleFieldComponent } from '../fields/form-toggle-field/form-toggle-field.component';
import { FormControlHintType } from '../form-control-hint-type.enum';
import { FormControlType } from '../form-control-type.model';
import { FormField } from '../form-field.model';

@Component({
  selector: 'iot-platform-ui-form-field',
  imports: [
    FlexLayoutModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    ReactiveFormsModule,
    TranslatePipe,
    NgTemplateOutlet,
    MatTooltipModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    FormsModule,
    NgClass,
    MatDatepickerModule,
    MatSlideToggleModule,
    NgComponentOutlet
  ],
  templateUrl: './form-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './form-field.component.scss'
})
export class FormFieldComponent {
  control = input<UntypedFormControl>();
  field = input<FormField>();
  FormControlType = FormControlType;
  FormControlHintType = FormControlHintType;

  onUndoBtnClicked(): void {
    const field = this.field();
    const control = this.control();
    control?.setValue(field?.undo?.initialValue?.());
    field?.undo?.onClick?.(field);
  }

  getFieldComponent(fieldType: FormControlType): Type<any> | null {
    switch (fieldType) {
      case FormControlType.AUTO_COMPLETE:
        return FormAutocompleteFieldComponent;
      case FormControlType.CHECKBOX:
        return FormCheckboxFieldComponent;
      case FormControlType.CHECKBOX_GROUP:
        return FormCheckboxGroupFieldComponent;
      case FormControlType.DATE_PICKER:
        return FormDatePickerFieldComponent;
      case FormControlType.DATE_TIME_PICKER:
        return FormDateTimePickerFieldComponent;
      case FormControlType.DROP_DOWN_LIST:
        return FormDropdownFieldComponent;
      case FormControlType.NUMBER:
        return FormNumberFieldComponent;
      case FormControlType.PASSWORD:
        return FormPasswordFieldComponent;
      case FormControlType.TEXT_AREA:
        return FormTextAreaFieldComponent;
      case FormControlType.TEXT:
        return FormTextFieldComponent;
      case FormControlType.TOGGLE:
        return FormToggleFieldComponent;
      default:
        console.warn(`Unsupported field type: ${fieldType}`);
        return null;
    }
  }
}
